/** @license DAFT Core v1.2.0
* Copyright 2020 Texas A&M Center for Applied Technology,
* Texas A&M Engineering Experiment Station, The Texas A&M
* University System.
*
* This source code/schema and any derivative work is Texas
* A&M Engineering Experiment Station intellectual property
* and protected by copyright law. Usage is restricted solely
* to the FARM Animal Care and Environmental Stewardship
* programs administered by the National Milk Producers
* Federation. Dissemination of this source code and/or
* derivative work creation is strictly prohibited without
* express written permission from the Texas A&M Engineering
* Experiment Station.
*/
import { switchMap } from 'rxjs/operators';
import { BehaviorSubject, combineLatest } from 'rxjs';

import { ProcessorFunction, isFieldName, parseFieldIdentifier } from "./processor";
import { ExpressionManager } from './ExpressionManager';
import { ArrayExpression, MapExpression } from './expressions';
import { DFSValueType } from './form';

export function isArrayExpression(exp: any): exp is ArrayExpression {
    if (isFieldName(exp)) {
      return true;
    }

    if (typeof exp === "string" || typeof exp === "number" || typeof exp === "boolean") {
      return false;
    }

    return exp.mapping !== undefined;
}

export const $map: ProcessorFunction<MapExpression, Array<DFSValueType>> = function(r, e, s) {
  return s.watch(r.source, e)
    .pipe(
      switchMap(e => {
        if (!Array.isArray(e)) {
          throw Error("$map source must be an Array, received '" + e + "'");
        }

        let o: ExpressionManager;
        let t: string;

        if (isFieldName(r.source)) {
          t = parseFieldIdentifier(r.source);
          o = s;
        } else {
          t = '';
          o = new ExpressionManager(new BehaviorSubject(e));
        }

        return combineLatest(e.map(function(_, s) {
          return o.watch(r.mapping, t.concat("/" + s));
        }))
      })
    )
};
